import { render } from "./AdminSetupView.vue?vue&type=template&id=451bae53&scoped=true"
import script from "./AdminSetupView.vue?vue&type=script&lang=js"
export * from "./AdminSetupView.vue?vue&type=script&lang=js"

import "./AdminSetupView.vue?vue&type=style&index=0&id=451bae53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451bae53"]])

export default __exports__